import { Button, Col, message, ModalProps, Radio, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Link } from 'react-router-dom';
import { paymentPackageAssigned } from 'src/api/package_assigned';
import {
  confirmTopupPackage,
  getDetailTopup,
  getTopupName,
} from 'src/api/register_and_cancel_and_load_package';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import Loading from 'src/components/CLoading';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { resetModalState, setModalState } from 'src/redux/slice/modal.store';
import { TransactionHistoryType } from 'src/shared/enum/localpay';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { TransactionHistory } from 'src/shared/interface/localpay.interface';
import { IOverFlowOrderDetailResponse, OrderRequest } from 'src/shared/interface/package_assigned';
import { formatDateTime, formatMoney, removeMoneyFormat } from 'src/utils';
interface ModalTopUpProps extends ModalProps {
  selectedHistory?: TransactionHistory;
}

function TopupPackageBillingInfoModal({ selectedHistory }: ModalTopUpProps) {
  const dispatch = useAppDispatch();
  const { order, refresh, balance, openTabs } = useAppSelector((state) => state.global);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');

  const [dataTopupName, setDataTopupName] = useState<string[]>([]);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [dataDetailLine, setDataDetailLine] = useState<
    {
      topupName: string;
      toTalAmount: number;
      countItem: number;
    }[]
  >([]);

  async function handlePayBill() {
    setIsModalLoading(true);
    setOpenModalConfirm(false);
    if (merchantInfo) {
      const data: OrderRequest = {
        accountNumber: JSON.parse(merchantInfo).payAccountId ?? '',
        orderId: order?.id ? order?.id : '',
        type: 16,
        distibutorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
        description: '',
        updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
      };
      try {
        // thanh toan don hang nap tien
        const res = await paymentPackageAssigned(data);
        if (res) {
          await confirmTopupPackage({ orderId: order?.id });

          dispatch(setGlobalState({ refresh: !refresh }));
          dispatch(setModalState({ open: false }));
          message.success('Thanh toán thành công');
        }
      } catch (error) {
        console.log(error);
        setIsModalLoading(false);
      }
    }
    dispatch(setGlobalState({ refresh: !refresh }));
  }

  const fetchDetailOrder = async (id: string) => {
    const res = await getDetailTopup(id);
    if (res) {
      const totalPrice =
        res.overFlowOrderDetailResponses?.reduce((item, { price }) => item + (price ?? 0), 0) ?? 0;
      dispatch(
        setGlobalState({
          order: { ...res, discountPrice: totalPrice - (res?.toTalAmount ?? 0) },
        }),
      );
    }
  };

  const fetchGetTopupName = async () => {
    await getTopupName().then((res: any) => {
      if (res) {
        const dataPackage: string[] = [];
        res?.map((item: any) => {
          dataPackage?.push(item.name ?? '');
        });
        setDataTopupName(dataPackage);
      }
    });
  };
  useEffect(() => {
    fetchGetTopupName();
  }, []);

  useEffect(() => {
    if (selectedHistory && selectedHistory.paymentId) {
      fetchDetailOrder(selectedHistory.paymentId);
    }
  }, [selectedHistory]);

  useEffect(() => {
    if (order) {
      const assignTopup = dataTopupName.map((predicate) => {
        return {
          topupName: predicate ?? '',
          toTalAmount: 0,
          countItem: 0,
        };
      });
      order?.overFlowOrderDetailResponses?.forEach((item: IOverFlowOrderDetailResponse) => {
        item.topupName?.filter((itemTopup) => {
          assignTopup?.filter((predicate, index) => {
            if (itemTopup === predicate.topupName) {
              assignTopup[index].toTalAmount =
                assignTopup[index].toTalAmount + Number(removeMoneyFormat(predicate.topupName));
              assignTopup[index].countItem = assignTopup[index].countItem + 1;
            }
          });
        });
      });
      setDataDetailLine(assignTopup.filter((predicate) => predicate.countItem > 0));
    }
  }, [order, dataTopupName]);

  const renderLinkDirectTo = () => {
    switch (selectedHistory?.type) {
      case TransactionHistoryType.RegisterPackage:
        return `/management/order-assigned-package/detail?id=${selectedHistory.paymentId}`;
      case TransactionHistoryType.CancelPackage:
        return `/management/register-and-cancel-and-load-package/cancel/detail?id=${selectedHistory.paymentId}`;
      case TransactionHistoryType.InitiatePackage:
        return `/management/register-and-cancel-and-load-package/register/detail?id=${selectedHistory.paymentId}`;
      case TransactionHistoryType.Datacode:
        return `/management/register-and-cancel-and-load-package/data-load/detail?id=${
          selectedHistory.paymentId || selectedHistory.id
        }`;
      default:
        return `changeSim/createChangeSim?id=${selectedHistory?.paymentId}`;
    }
  };

  const openMenuTab = () => {
    let url = '';
    let label = '';
    if (selectedHistory?.type === TransactionHistoryType.RegisterPackage) {
      url = 'order-assigned-package/detail';
      label = `Xem chi tiết Gán gói`;
    } else if (selectedHistory?.type === TransactionHistoryType.CancelPackage) {
      url = 'register-and-cancel-and-load-package/cancel/detail';
      label = `Xem chi tiết Hủy gói`;
    } else if (selectedHistory?.type === TransactionHistoryType.InitiatePackage) {
      url = 'register-and-cancel-and-load-package/register/detail';
      label = `Xem chi tiết Đăng ký gói`;
    } else if (selectedHistory?.type === TransactionHistoryType.Datacode) {
      url = 'register-and-cancel-and-load-package/data-load/detail';
      label = `Xem chi tiết Nạp data`;
    } else if (selectedHistory?.type === TransactionHistoryType.EnterpriseTopup) {
      url = 'topup/detail';
      label = `Xem chi tiết Nạp tiền`;
    } else {
      url = 'changeSim/createChangeSim';
      label = `Xem chi tiết Đổi sim`;
    }

    dispatch(
      setGlobalState({
        activeKeyMenu: `${url}?id=${selectedHistory?.paymentId || selectedHistory?.id}`,
      }),
    );
    dispatch(
      setGlobalState({
        openTabs: [
          ...openTabs,
          {
            label: `${label} ${selectedHistory?.paymentId || selectedHistory?.id}`,
            children: '',
            key: `${url}?id=${selectedHistory?.paymentId || selectedHistory?.id}`,
            closable: true,
          },
        ],
      }),
    );
  };

  return (
    <Fragment>
      {isModalLoading && <Loading />}
      <div className='flex justify-end'>
        <button
          onClick={() => dispatch(resetModalState())}
          className=' text-3xl cursor-pointer border-transparent bg-transparent'
        >
          <RxCross2 />
        </button>
      </div>
      <BoxWithLabel title='Thông tin thanh toán' classNames='mb-[1.5rem]'>
        <Row gutter={[12, 12]} className='mb-[1rem]'>
          <Col span={24} md={12}>
            <Row gutter={[0, 8]}>
              <Col span={24}>Mã giao dịch: {order?.transactionId}</Col>
              <Col span={24}>
                Ngày:{' '}
                {order?.transactionDate && new Date(order.transactionDate).getFullYear() > 1900
                  ? formatDateTime(order.transactionDate)
                  : formatDateTime(new Date())}
              </Col>
              <Col span={24}>Diễn giải: Thanh toán đơn hàng Nạp tiền</Col>
            </Row>
          </Col>
          <Col span={24} md={12}>
            <Row gutter={[0, 8]}>
              <Col span={24}>Tình trạng: {order?.transactionStatusString}</Col>
              <Col span={24}>
                Người thanh toán: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
              </Col>
              <Col span={24}>
                Đơn hàng tham chiếu:{' '}
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(resetModalState());
                    openMenuTab();
                  }}
                  className='hover:underline underline'
                  to={renderLinkDirectTo()}
                >
                  {order?.id}
                </Link>{' '}
              </Col>
            </Row>
          </Col>
        </Row>
        <p className='font-bold mb-[0.5rem]'>Chi tiết hóa đơn:</p>
        <div className='normal-table max-h-80 overflow-y-auto'>
          <table width='100%' className='normal-table'>
            <thead>
              <tr>
                <th>STT</th>
                <th>Số lượng</th>
                <th>Mệnh giá</th>
                <th>Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              {dataDetailLine.map((predicate, index) => {
                if (predicate.countItem) {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{predicate.countItem ?? 1}</td>
                      <td>{predicate?.topupName ? predicate?.topupName + 'đ' : ''}</td>
                      <td>
                        {predicate?.toTalAmount ? formatMoney(predicate?.toTalAmount, 'đ') : '-'}
                      </td>
                    </tr>
                  );
                } else {
                  return <></>;
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td>Chiết khấu</td>
                <td>{order?.discountPrice ? formatMoney(order?.discountPrice, 'đ') : '-'}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td>Tổng cộng</td>
                <td>{order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </BoxWithLabel>
      <BoxWithLabel title='Hình thức thanh toán' classNames='mb-[1.5rem]'>
        <Radio checked className='mb-[0.5rem]'>
          Localpay
        </Radio>
        <Row gutter={[12, 8]}>
          <Col span={24} md={8}>
            LocalPay ID: {merchantInfo ? JSON.parse(merchantInfo).payAccountId : '-'}
          </Col>
          <Col span={24} md={8}>
            Tên chủ tài khoản: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
          </Col>
          {(order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
            order?.statusString === OrderStatusEnum.New) && (
            <>
              <Col span={24} md={8}>
                Số dư: {balance ? formatMoney(balance, 'đ') : '-'}
              </Col>
            </>
          )}
        </Row>
      </BoxWithLabel>
      {!(
        order?.transactionStatusString === OrderStatusEnum.PAYMENT_FAIL ||
        order?.statusString === OrderStatusEnum.New
      ) && (
        <Row className='my-4 border px-4 py-2' gutter={[12, 8]}>
          <Col span={24} md={12}>
            Người tạo: {order?.createdBy}
          </Col>
          <Col span={24} md={12}>
            Ngày tạo: {order?.createdAt ? formatDateTime(order.createdAt) : '-'}
          </Col>
        </Row>
      )}
      {(order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
        order?.statusString === OrderStatusEnum.New) && (
        <div className='row-button justify-end'>
          <Button
            onClick={() => setOpenModalConfirm(true)}
            disabled={
              order?.statusString !== OrderStatusEnum.PAYMENT_FAIL &&
              order?.statusString !== OrderStatusEnum.New
            }
          >
            Thanh toán
          </Button>
        </div>
      )}
      <ModalConfirm
        open={openModalConfirm}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Xác nhận thanh toán?</div>
            <p>
              Bạn có chắc chắn muốn thanh toán{' '}
              {order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '-'} cho{' '}
              {order?.countSerial ?? 0} STB thực hiện nạp tiền?
            </p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handlePayBill} className='h-full w-full' disabled={isModalLoading}>
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirm(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
    </Fragment>
  );
}

export default TopupPackageBillingInfoModal;
